import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import mobile from 'is-mobile';
import { toast } from 'react-toastify';
import Mobile from '../compositions/Toast/Mobile';
import Desktop from '../compositions/Toast/Desktop';

export const ToastCtx = createContext();

const ToastProvider = ({ children }) => {
  const [alert, setAlert] = useState();
  const [alertOpen, setAlertOpen] = useState(false);

  return (
    <ToastCtx.Provider
      value={{
        dispatch: (title, type, description, presentation, custom, store) => {
          const message =
            typeof title === 'object'
              ? {
                  type: title.type || type,
                  title: title.title,
                  description: title.description,
                  presentation: title.presentation || presentation,
                  custom: title.custom || custom,
                  store: title.store || store,
                }
              : {
                  type,
                  title,
                  description,
                  presentation,
                  custom,
                  store,
                };

          if (mobile() && !message.custom) {
            toast(
              <Mobile title={message.title} type={message.type}>
                {message.description}
              </Mobile>,
            );
          } else {
            setAlert(message);
            setAlertOpen(true);
          }
        },
        close: () => setAlertOpen(false),
        toastIsOpened: alertOpen,
      }}
    >
      {children}

      {(!mobile() || !!alert?.custom) && (
        <Desktop
          title={alert?.title}
          type={alert?.type}
          description={alert?.description}
          presentation={alert?.presentation}
          custom={alert?.custom}
          store={alert?.store}
          modalProps={{
            handleClose: () => {
              setAlertOpen(false);
              setTimeout(() => {
                setAlert(null);
              }, 600);
            },
            open: alertOpen,
          }}
        />
      )}
    </ToastCtx.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
};

export default ToastProvider;
